var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b5748;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.83,49.49h-16.73c-.25,0-.47-.16-.54-.4l-5.65-17.8h-6.1c-.31,0-.57-.25-.57-.57s.25-.57.57-.57h6.51c.25,0,.47.16.54.4l5.65,17.8h15.89l3.52-11.93h-15.68c-.31,0-.57-.25-.57-.57s.25-.57.57-.57h16.43c.18,0,.35.08.45.23.11.14.14.33.09.5l-3.85,13.06c-.07.24-.29.41-.54.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.1,59.18c-2.07,0-3.75-1.67-3.75-3.72s1.68-3.72,3.75-3.72,3.75,1.67,3.75,3.72-1.68,3.72-3.75,3.72ZM40.1,52.87c-1.44,0-2.62,1.16-2.62,2.59s1.17,2.59,2.62,2.59,2.62-1.16,2.62-2.59-1.17-2.59-2.62-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.47,59.18c-2.07,0-3.75-1.67-3.75-3.72s1.68-3.72,3.75-3.72,3.75,1.67,3.75,3.72-1.68,3.72-3.75,3.72ZM53.47,52.87c-1.44,0-2.62,1.16-2.62,2.59s1.17,2.59,2.62,2.59,2.62-1.16,2.62-2.59-1.17-2.59-2.62-2.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ae216086a64598b6c2f662ee4f71ef5e.svg";
export { ForwardRef as ReactComponent };